/** @format */

const months = 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_');
const monthsShort = 'janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc'.split('_');
const weekdays = 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split('_');
const weekdaysShort = 'Dim_Lun_Mar_Mer_Jeu_Ven_Sam'.split('_');
const weekdaysMin = 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_');

export { months, monthsShort, weekdays, weekdaysShort, weekdaysMin };
